/** Dates as the portal prints them: Ghana time is UTC. */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.toISOString().slice(0, 16).replace('T', ' ')} UTC`;
}

export function formatDate(value: string | null | undefined): string {
  return value ? value.slice(0, 10) : '';
}

/** "5 minutes ago", "3 days ago"; the date itself after a month. */
export function relativeTime(
  value: string | null | undefined,
  now: Date = new Date(),
): string {
  if (!value) return '';
  const then = new Date(value);
  if (Number.isNaN(then.getTime())) return '';
  const seconds = Math.round((now.getTime() - then.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  if (seconds >= 86400 * 30) return formatDate(value);
  let size = 60;
  let name = 'minute';
  if (seconds >= 86400) {
    size = 86400;
    name = 'day';
  } else if (seconds >= 3600) {
    size = 3600;
    name = 'hour';
  }
  const count = Math.floor(seconds / size);
  return `${count} ${name}${count === 1 ? '' : 's'} ago`;
}

/** `staff.set_roles` -> `Staff set roles`. */
export function actionLabel(action: string): string {
  const text = action.replaceAll('.', ' ').replaceAll('_', ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** "SAOO11B2…60BE4": keeps the ends of a long reference. */
export function middleTruncate(value: string, head = 8, tail = 5): string {
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}
